interface RequisitesProps {
  className?: string;
  data: {
    OwnerName?: string | null;
    Id?: string;
    Name?: string;
    BankName?: string;
    BankAddress?: string;
    BIC?: string;
    IBAN?: string;
    BeneficiaryAddress?: string;
    CreditAccount?: string;
    Amount?: number;
    DebitAccount?: string;
    Date?: string;
  };
}

export const Requisites = (props: RequisitesProps) => {
  if (!props.data) return null;

  const filteredData = Object.fromEntries(
    Object.entries(props.data).filter(([key, value]) => key !== 'Id' && value !== null && value !== undefined && value !== ''),
  );
  return (
    <>
      <div className='requisites-title'> Account top up</div>
      <div className='requisites-table'>
        <div className='requisites-row'>
          <div className='requisites-cell header'>BENEFICIARY NAME</div>
          <div className='requisites-cell'>{filteredData.OwnerName || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>BENEFICIARY ADDRESS</div>
          <div className='requisites-cell'>{filteredData.BeneficiaryAddress || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>IBAN / ACCOUNT NUMBER</div>
          <div className='requisites-cell'>{filteredData.IBAN || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>BIC / SWIFT</div>
          <div className='requisites-cell'>{filteredData.BIC || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>BANK</div>
          <div className='requisites-cell'>{filteredData.BankName || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>BANK ADDRESS</div>
          <div className='requisites-cell'>{filteredData.BankAddress || '-'}</div>
        </div>
        <div className='requisites-row'>
          <div className='requisites-cell header'>PAYMENT REFERENCE</div>
          <div className='requisites-cell'>{filteredData.Name || '-'}</div>
        </div>
      </div>
    </>
  );
};
